import React from 'react';
import { useTranslation } from "react-i18next";
import { View } from "@/styles/reactnative";
import useTradeStore from "@app/hooks/trade/tradeStore.tsx";

const OrderPreferenceCheckBox = ({
  checked,
  setOrderByValue,
  orderByValue,
  setOrderQty,
  orderQty,
  type,
  title,
  content,
  coinType,
}) => {
  const { t } = useTranslation();
  const { data: tradeStore, mutate } = useTradeStore();

  const handleChange = async (e) => {
    if (tradeStore) {
      if (e) {
        localStorage.setItem('main_sub', type === "qty" ? "M" : "S");

        await mutate({
          ...tradeStore,
          main_sub: type === "qty" ? "M" : "S",
          coin_type: type === "qty" ? tradeStore?.symbol : "USDT",
          order_amount: 0,
        });

      }
    } else {
      console.error("tradeStore is undefined");
    }
  };

  return (
    <View
      style={{
        flexDirection: "row",
        width: "100%",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        marginTop: 20,
        gap: 10,
      }}
    >
      {/* Custom CheckBox with #07D993 color */}
      <div
        style={{
          width: 16,
          height: 16,
          borderRadius: 4,
          backgroundColor: checked ? '#07D993' : 'transparent',
          border: checked ? 'none' : '2px solid #777986',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          flexShrink: 0,
        }}
        onClick={() => handleChange(true)}
      >
        {checked && (
          <svg width="10" height="10" viewBox="0 0 14 14" fill="none">
            <path
              d="M10.3198 4.03711C10.5749 3.7873 10.9874 3.78752 11.2426 4.03711C11.4996 4.2888 11.4996 4.6985 11.2426 4.9502L6.12542 9.96289C5.99762 10.0879 5.83043 10.1503 5.66448 10.1504C5.49831 10.1504 5.33051 10.0881 5.20257 9.96289L2.75725 7.56738C2.50029 7.31569 2.50029 6.90599 2.75725 6.6543C3.01245 6.40444 3.42495 6.40438 3.68011 6.6543L5.6635 8.59668L10.3198 4.03711Z"
              fill="white"
              stroke="white"
              strokeWidth="0.3"
            />
          </svg>
        )}
      </div>
      <View style={{ alignItems: "flex-start", width: "100%", flex: 1 }}>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div
            style={{
              fontSize: 13,
              fontWeight: 700,
              color: '#fff',
              letterSpacing: '-0.36px',
              fontFamily: 'NanumSquareRound',
              marginBottom: 4,
            }}
          >
            {title && t(title)}
          </div>
          <div
            style={{
              fontSize: 13,
              fontWeight: 700,
              color: '#07D993',
              letterSpacing: '-0.36px',
              fontFamily: 'NanumSquareRound',
            }}
          >
            {coinType}
          </div>
        </View>
        <div
          style={{
            fontSize: 12,
            fontWeight: 400,
            color: '#b3b5bd',
            letterSpacing: '-0.36px',
            fontFamily: 'NanumSquareRound',
            lineHeight: 1.4,
          }}
        >
          {content && t(content)}
        </div>
      </View>
    </View>
  );
};

export default OrderPreferenceCheckBox;
